import { Component, OnInit } from '@angular/core';
//import { Router,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-adminayuda',
  templateUrl: './adminayuda.component.html',
  styleUrls: ['./adminayuda.component.scss']
})
export class AdminayudaComponent implements OnInit {

  constructor(
    // private route: ActivatedRoute,
    // private router: Router
  ) {

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminayuda/adminayuda.component.ts